/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AssignmentStatus } from '../../models/assignment-status';
import { AvailableCrewResponse } from '../../models/available-crew-response';
import { Rank } from '../../models/rank';
import { Rotation } from '../../models/rotation';
import { WingType } from '../../models/wing-type';

export interface ListAvailableCrew$Params {
  dateFrom: string;
  dateTo: string;

/**
 * Omit or empty = all rotations. Does not change stored Rotation.
 */
  rotation?: Array<Rotation>;

/**
 * Omit = all ranks (P/S/T).
 */
  rank?: Rank;

/**
 * Omit = all wing types.
 */
  wingType?: WingType;

/**
 * Filter by overlap with the requested Date Range. Omit = return both assigned and unassigned, each with `available` set. UNASSIGNED = no overlapping allocation; ASSIGNED = at least one overlapping allocation.
 */
  assignmentStatus?: AssignmentStatus;
  search?: string;
}

export function listAvailableCrew(http: HttpClient, rootUrl: string, params: ListAvailableCrew$Params, context?: HttpContext): Observable<StrictHttpResponse<AvailableCrewResponse>> {
  const rb = new RequestBuilder(rootUrl, listAvailableCrew.PATH, 'get');
  if (params) {
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
    rb.query('rotation', params.rotation, {"style":"form","explode":true});
    rb.query('rank', params.rank, {});
    rb.query('wingType', params.wingType, {});
    rb.query('assignmentStatus', params.assignmentStatus, {});
    rb.query('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AvailableCrewResponse>;
    })
  );
}

listAvailableCrew.PATH = '/api/scheduler/master-schedule/available-crew';
